import { addMissingCurrencies, LocaleData } from '@assetaccountant/core/models/currencies';

export const decorateLocale = (localeData: LocaleData): LocaleData => {
  let result = localeData;

  result = addMissingCurrencies(result);

  return result;
};
